import React from 'react';
import { I18n } from '@aws-amplify/core';
import { ColumnsType } from 'antd/es/table';
import { Col, Row, Table } from 'antd';

import { KimLiftingHoldingCarryingGenderResult } from '@/hooks';
import { RISK_LEVEL_COLORS } from '@/components/views/Report/KimLhc/Report/Steps/Result/Constants';

import { formatScore, RiskSummary } from './utils';

import * as S from './styles';

interface ScoreRow {
	key: React.Key;
	woman: string;
	man: string;
}

interface DetailRow {
	key: React.Key;
	probability: string;
	consequences: string;
	measures: string;
}

interface CombinedRiskResultProps {
	id: string;
	woman: KimLiftingHoldingCarryingGenderResult;
	man: KimLiftingHoldingCarryingGenderResult;
	summary: RiskSummary;
}

export function CombinedRiskResult(props: Readonly<CombinedRiskResultProps>): JSX.Element {
	const { id, woman, man, summary } = props;

	const scoreColumns: ColumnsType<ScoreRow> = [
		{
			title: I18n.get('Score for women'),
			dataIndex: 'woman',
			key: 'woman'
		},
		{
			title: I18n.get('Score for men'),
			dataIndex: 'man',
			key: 'man'
		}
	];

	const scoreData: ScoreRow[] = [
		{
			key: id,
			woman: formatScore(woman.score, woman.risk),
			man: formatScore(man.score, man.risk)
		}
	];

	const detailColumns: ColumnsType<DetailRow> = [
		{
			title: I18n.get('Probability of physical overload'),
			dataIndex: 'probability',
			key: 'probability',
			width: '33.3333%'
		},
		{
			title: I18n.get('Possible health consequences'),
			dataIndex: 'consequences',
			key: 'consequences',
			width: '33.3333%'
		},
		{
			title: I18n.get('Measures'),
			dataIndex: 'measures',
			key: 'measures',
			width: '33.3333%'
		}
	];

	const detailData: DetailRow[] = [
		{
			key: 'kim-lhc-detail',
			probability: summary.risk_level,
			consequences: summary.health_consequences,
			measures: summary.measures
		}
	];

	return (
		<Row gutter={[0, 16]}>
			<Col span={24}>
				<S.KimLhcTableContainerFirstRow
					$womanColor={RISK_LEVEL_COLORS[woman.risk]}
					$manColor={RISK_LEVEL_COLORS[man.risk]}
				>
					<Table columns={scoreColumns} dataSource={scoreData} pagination={false} />
				</S.KimLhcTableContainerFirstRow>
			</Col>
			<Col span={24}>
				<S.KimLhcTableContainerSecondRow>
					<Table columns={detailColumns} dataSource={detailData} pagination={false} />
				</S.KimLhcTableContainerSecondRow>
			</Col>
		</Row>
	);
}
